var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHeader = void 0;
var CardHeader_1 = __importDefault(require("./CardHeader"));
exports.CardHeader = CardHeader_1.default;
exports.default = CardHeader_1.default;
//# sourceMappingURL=index.js.map